import React from 'react'
import {map} from "lodash";
import {Icon, Label} from "semantic-ui-react";
import styled from 'styled-components';

import { ApplyDiscount } from '~/components/cart'

import logic from './logic'

const CodeBlock = styled.div`
  text-align: right;
  padding: 14px 0;
`;

@logic
export default class DiscountComponent extends React.PureComponent {
  handleApply = (code) => {
    const { applyCode } = this.props.actions;
    applyCode(code);
  };

  handleRemoveCode = (code) => {
    const { removeCode } = this.props.actions;
    removeCode(code);
  };

  render() {
    const {
      activeCart,
      showDiscountInput,
      applyingCode,
      discountError,
      appliedCodes,
    } = this.props;

    return (
      <div>
        { map(appliedCodes, (code) => {
          return (
            <CodeBlock key={ code }>
              <Label size='large' color='red'>
                { code }
              </Label>
              <Icon name='trash alternate' link onClick={ (e) => {
                e.preventDefault();
                this.handleRemoveCode(code);
              }}/>
            </CodeBlock>
          )
        })}
        { showDiscountInput ?
          <CodeBlock>
            <ApplyDiscount onApply={ this.handleApply } activeCart={ activeCart } error={ discountError } loading={ applyingCode } />
          </CodeBlock>
          : null }
      </div>
    )
  }
}